const OSS = require('ali-oss')
export default {
    /**
     * 阿里云oss sdk文件上传  dir 上传到的文件位置
     * @param {*} file 文件流
     * @param {*} successCallback 成功回调
     * @param {*} errCallBack 失败回调
     * @param {*} bucketName 阿里云桶名（可以指定多个桶名）
     * @param {*} dir 上传文件夹路径  譬如images
     */

    bucketUpload(file, successCallback = new Function(), errCallBack = new Function(), bucketName = 'duole-images', dir = '/pc-image/') {
        // 先获取上传要的资料签名
        let fileName = new Date().getTime() + '.png'
        if(file.name) fileName = new Date().getTime() + file.name

        // req.getUploadVoucher().then((res) => {
        //     if (res.code === 0) {
        //         let obj = res.result.filePath.credentials || {}
                let obj =  {}
                let config = {}
                // config.host = obj.OssUrl
                // 实例化一个上传客户端
                const client = new OSS({
                    // yourRegion填写Bucket所在地域。Region填写为oss-cn-hangzhou。
                    // region: "oss-cn-beijing", //我的存储是北京，可根据具体配置自行修改
                    region: 'oss-cn-beijing',
                    // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。）（后台接口返回）
                    accessKeyId: 'LTAI5tPJ5FDzgTuvBSCKKP88',
                    accessKeySecret: 'IyYA5aJVIK2wdfFReyHjVoT2Be3WQF',
                    // 从STS服务获取的安全令牌（SecurityToken）。
                    // stsToken: obj.securityToken,
                    // 填写Bucket名称。
                    bucket: 'duole-images',
                    endpoint:"oss-cn-beijing.aliyuncs.com",
                    secure: true,// 是否使用https
                })

                // try {
                //     // 为保证唯一性，可以通过uuid将文件名替换
                //     // let uuid = uuidv4() + fileName.substring(fileName.lastIndexOf('.'))if (dir.substring(dir.length - 1, 1) !== '/') {
                //     dir += '/'
                // }
                const result = client.put(dir + fileName, file)
                result
                    .then(res => {
                        console.log(res,"返回文件名和文件地址")
                        let size = file.size > 1000000 ? parseFloat(file.size / 1000000).toFixed(2) + 'M' : parseFloat(file.size / 1000).toFixed(2) + 'KB'
                        successCallback({
                            attachment: fileName,
                            url: res.url,
                            size: size,
                            host: config.host
                        })
                    })
                    .catch(err => {
                        errCallBack(err)
                    })
            // }
            // catch (e) {
            //     console.log(e)
            // }
        // }
        // else {
        //     // _this.$message.warning(res.msg);
        // }
    // });
}
}
